import { viewForwardCurve } from "../../actions/view-forward-curve";
import type { GetContextMenuSection } from "./helpers";
import { getIcon } from "./icons";
import { useUserSubscriptionTier } from "../../../data/user";

export const useGetMenuItemsChartRange = (): GetContextMenuSection => {
  const { disabledFeatures } = useUserSubscriptionTier();

  return (ctx) => {
    if (ctx.isHeaderMenu || ctx.isShadowCurve) return [];

    if (!ctx.api.getCellRanges()?.length) return [];

    return [
      {
        name: "View Forward Curve",
        icon: getIcon("lineChart"),
        disabled: disabledFeatures?.hfc,
        tooltip: disabledFeatures?.hfc ? "Please upgrade your subscription to access this feature" : undefined,
        action: () => {
          viewForwardCurve(ctx);
        },
      },
    ];
  };
};
